var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalcium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 527,
    viewBox: "0 0 500 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 263.041,
    r: 249,
    stroke: "#BED2C2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 263.041,
    r: 199,
    stroke: "#BED2C2",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 263.041,
    r: 99,
    stroke: "#BED2C2",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 262.541,
    r: 37.5,
    fill: "#9BA989"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 263.041,
    r: 149,
    stroke: "#BED2C2",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 62.541,
    r: 12.5,
    fill: "#9BA989"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 112.541,
    r: 12.5,
    fill: "#9BA989"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.5,
    cy: 155.5,
    r: 12.5,
    fill: "#9BA989"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 12.541,
    r: 12.5,
    fill: "#9BA989"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 162.541,
    r: 12.5,
    fill: "#9BA989"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.5,
    cy: 262.5,
    r: 12.5,
    fill: "#9BA989"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 262.5,
    r: 12.5,
    fill: "#9BA989"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.5,
    cy: 119.5,
    r: 12.5,
    fill: "#9BA989"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.709,
    cy: 372.194,
    r: 12.5,
    transform: "rotate(92.4795 348.709 372.194)",
    fill: "#9BA989"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.073,
    cy: 410.758,
    r: 12.5,
    transform: "rotate(92.4795 384.073 410.758)",
    fill: "#9BA989"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.03,
    cy: 463.03,
    r: 12.5,
    transform: "rotate(92.4795 251.03 463.03)",
    fill: "#9BA989"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.03,
    cy: 119.03,
    r: 12.5,
    transform: "rotate(92.4795 113.03 119.03)",
    fill: "#9BA989"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.03,
    cy: 155.03,
    r: 12.5,
    transform: "rotate(92.4795 146.03 155.03)",
    fill: "#9BA989"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0295,
    cy: 263.03,
    r: 12.5,
    transform: "rotate(92.4795 50.0295 263.03)",
    fill: "#9BA989"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.03,
    cy: 262.03,
    r: 12.5,
    transform: "rotate(92.4795 100.03 262.03)",
    fill: "#9BA989"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.03,
    cy: 400.03,
    r: 12.5,
    transform: "rotate(92.4795 112.03 400.03)",
    fill: "#9BA989"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.03,
    cy: 368.03,
    r: 12.5,
    transform: "rotate(92.4795 145.03 368.03)",
    fill: "#9BA989"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.03,
    cy: 363.03,
    r: 12.5,
    transform: "rotate(92.4795 250.03 363.03)",
    fill: "#9BA989"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.03,
    cy: 413.03,
    r: 12.5,
    transform: "rotate(92.4795 250.03 413.03)",
    fill: "#9BA989"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.03,
    cy: 513.03,
    r: 12.5,
    transform: "rotate(92.4795 250.03 513.03)",
    fill: "#9BA989"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcium);
export default __webpack_public_path__ + "static/media/calcium.72122dcadc79b7a7277279e137e85196.svg";
export { ForwardRef as ReactComponent };